import { memo } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';
// config
import { HEADER } from '../../../config';
// components
import { NavSectionHorizontal } from '../../../components-custom/nav-section';
// hooks
import useAuth from '../../../hooks/useAuth';
//
import navConfig from './NavConfig';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  transition: theme.transitions.create('top', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  boxShadow: theme.customShadows.z8,
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

function NavbarHorizontal() {
  const { user, hasPermissions } = useAuth();

  const permissionNavConfig = navConfig
    .map((item) => ({
      ...item,
      items: item.items.filter(
        (sitem) => hasPermissions(sitem.permissions) && (!sitem.condition || (sitem.condition && sitem.condition(user)))
      ),
    }))
    .filter((item) => item.items.length > 0);

  return (
    <RootStyle>
      <Container maxWidth={false}>
        <NavSectionHorizontal navConfig={permissionNavConfig} />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);
